<template>
  <div>
    <div class="modal-toptitle">
      <slot name="title"></slot>
    </div>

    <svg
      v-if="hasCloseIcon"
      @click="hide()"
      class="modal-close-icon"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
        fill="#F46A6A"
      />
    </svg>

    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="modal-spinner"
    />

    <template v-else>

      <div :class="{ 'align-left': alignLeft, 'align-center': !alignLeft }">

        <div class="modal-body-content">
          <span class="modal-text1">
            <slot name="text1"></slot>
          </span>
          
          <slot name="text2"></slot>

          <span class="modal-text1" v-if="$slots['text1-1']">
            <slot name="text1-1"></slot>
          </span>

          <slot name="text3"></slot>

          <slot name="textArea"></slot>
        </div>

        <!-- Conditional horizontal line and footer buttons slot -->
        <div v-if="$slots.buttons">
          <hr class="vertical-line" />
          <div class="modal-actions-btns">
            <slot name="buttons"></slot>
          </div>
        </div>


      </div>


    </template>
  </div>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
      default:"confirmModal"
    },
    hasCloseIcon: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    alignLeft: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hide() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style lang="scss">
[id*="ConfirmModal"] {
  .modal-content {
    width: 500px !important;
    top: 170px;
    border-radius: 26px;
    .modal-toptitle {
      margin-top: 0 !important;
      display: flex;
      justify-content: center;
      span {
        font-size: 17px;
        font-weight: 700;
        line-height: 20.4px;
        color: #000000;
      }
    }

    .modal-body {
      position: relative;
      padding: 40px 40px 24px 40px !important;
      text-align: center;
      text-align: -webkit-center;
    }

    .modal-close-icon {
      position: absolute;
      top: 32px;
      inset-inline-end: 32px;
      cursor: pointer;
    }

    .modal-body-content {
      padding: 40px 0px;
      display: grid;
      gap: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #4a4a4a;
      span {
        max-width: 416px;
        word-wrap: break-word;
      }
    }

    .align-left {
      text-align: start !important;
    }

    .align-center {
      text-align: center !important;
    }

    .modal-body-content .modal-text1 {
      line-height: 23.28px;
    }

    .modal-actions-btns {
      display: flex;
      justify-content: center;
      gap: 32px;
    }

    .vertical-line {
      width: 420px;
      border-top: 1px solid #70707015;
      margin: 0 0 24px 0 !important;
      display: flex;
      margin-inline-start: auto;
      margin-inline-end: auto;
    }
  }
}
</style>
